import { render, staticRenderFns } from "./DataLoggerList.vue?vue&type=template&id=87a0407c&scoped=true"
import script from "./DataLoggerList.vue?vue&type=script&lang=js"
export * from "./DataLoggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a0407c",
  null
  
)

export default component.exports